import { useAuth } from '../context/AuthContext'

export function usePermission() {
  const { hasPermission, hasAnyPermission, hasAllPermissions, isAdmin, permissions } = useAuth()

  return {
    hasPermission,
    hasAnyPermission,
    hasAllPermissions,
    isAdmin,
    permissions,
  }
}
